import React, { useEffect, useState } from 'react';
import '../patientForm.css';
import { Formik, Form, useFormik, ErrorMessage, Field } from 'formik';
import { Loader, Select, SuccessModal } from '@ohif/ui';
import { PatientPropsType } from '@custom/Utils/constants/interfaces';
import { apiRequest } from '@custom/Utils/config/apiRequest';
import { _modalityQues, _patientUrls } from '@custom/Utils/constants/apiUrls';
import { servicesManager } from '../../../app/src/App';
import { useNavigate, useLocation } from 'react-router-dom';
import { customStyle } from '@custom/Utils/utils';
import { sampleFormSchema } from '@custom/Utils/schema/schema';
import dayjs from "dayjs";
import { Space, TimePicker } from "antd";
import { _roleType } from '@custom/Utils/constants/appConstants';

const AllregiesAndReasonForVisit = (props: PatientPropsType) => {
  const location = useLocation();
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);

  const data = useLocation();
  const [load, setLoad] = useState(false);
  const navigate = useNavigate();
  const role = sessionStorage.getItem('role');

  console.log('props.patient', props.patient);

  const { uiNotificationService } = servicesManager.services;

  const capitaliseLetter = str => {
    if (!str) {
      return null;
    }
    return str
      .split(/[ _]/)
      .map(word => {
        if (word) {
          return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        } else {
          return '';
        }
      })
      .join(' ');
  };

  const getInitialValues = () => {
    const sampleOptions = ['Breast', 'Lung', 'Colon', 'Colorectal', 'Prostate', 'Other'];

    if (data.state.mode == 'edit') {
      const rawSampleLoc = data?.state?.patientDetails?.patientDetail?.healthCareInfo?.sampleLocation
        ? capitaliseLetter(data?.state?.patientDetails?.patientDetail?.healthCareInfo?.sampleLocation)
        : data?.state?.patientDetails?.patientDetail?.healthCareInfo?.[0]?.sampleLocation
          ? capitaliseLetter(data?.state?.patientDetails?.patientDetail?.healthCareInfo?.[0]?.sampleLocation)
          : '';

      const typeOfSampleRaw = data?.state?.patientDetails?.patientDetail?.healthCareInfo?.typeOfSample
        ? data?.state?.patientDetails?.patientDetail?.healthCareInfo?.typeOfSample
        : data?.state?.patientDetails?.patientDetail?.healthCareInfo?.[0]?.typeOfSample || '';

      const isTissue = typeOfSampleRaw === 'Tissue';

      const editData = {
        typeOfSample: typeOfSampleRaw,
        sampleLocation: isTissue ? (rawSampleLoc && sampleOptions.includes(rawSampleLoc) ? rawSampleLoc : (rawSampleLoc ? 'Other' : '')) : rawSampleLoc,
        sampleLocationOther: isTissue && rawSampleLoc && !sampleOptions.includes(rawSampleLoc) ? rawSampleLoc : '',
        sampleTime: data?.state?.patientDetails?.patientDetail?.healthCareInfo?.sampleTime ? convertTo24HourFormat(data?.state?.patientDetails?.patientDetail?.healthCareInfo?.sampleTime) : data?.state?.patientDetails?.patientDetail?.healthCareInfo?.[0]?.sampleTime ? convertTo24HourFormat(data?.state?.patientDetails?.patientDetail?.healthCareInfo?.[0]?.sampleTime) : '',
        slideCreationTime: data?.state?.patientDetails?.patientDetail?.healthCareInfo?.slideCreationTime ? convertTo24HourFormat(data?.state?.patientDetails?.patientDetail?.healthCareInfo?.slideCreationTime) : data?.state?.patientDetails?.patientDetail?.healthCareInfo?.[0]?.slideCreationTime ? convertTo24HourFormat(data?.state?.patientDetails?.patientDetail?.healthCareInfo?.[0]?.slideCreationTime) : '',
        priority: data?.state?.patientDetails?.patientDetail?.healthCareInfo?.priority ? data?.state?.patientDetails?.patientDetail?.healthCareInfo?.priority : data?.state?.patientDetails?.patientDetail?.healthCareInfo?.[0]?.priority ? data?.state?.patientDetails?.patientDetail?.healthCareInfo?.[0]?.priority : '',
        allergies: data.state?.patientDetails?.patientDetail?.healthCareInfo?.[0]?.allergies || "",
        currentMedications: data.state?.patientDetails?.patientDetail?.healthCareInfo?.[0]?.currentMedication || "",
        relevantMedicalHistory: data.state?.patientDetails?.patientDetail?.healthCareInfo?.[0]?.relMedicalHist || "",
        previousSurgeriesOrProcedures: data.state?.patientDetails?.patientDetail?.healthCareInfo?.[0]?.prevSurgery || "",
      };

      return editData
    } else if (data.state.mode == 'create') {
      const rawSampleLoc = props.patient?.healthCareInfo?.[0]?.sampleLocation ? capitaliseLetter(props.patient?.healthCareInfo?.[0]?.sampleLocation) : '';
      const typeOfSampleRaw = props.patient?.healthCareInfo?.[0]?.typeOfSample || "";
      const isTissue = typeOfSampleRaw === 'Tissue';

      const initialData = {
        typeOfSample: typeOfSampleRaw || "",
        sampleLocation: isTissue ? (rawSampleLoc && sampleOptions.includes(rawSampleLoc) ? rawSampleLoc : (rawSampleLoc ? 'Other' : '')) : rawSampleLoc,
        sampleLocationOther: isTissue && rawSampleLoc && !sampleOptions.includes(rawSampleLoc) ? rawSampleLoc : '',
        sampleTime: props.patient?.healthCareInfo?.[0]?.sampleTime || "",
        priority: props.patient?.healthCareInfo?.[0]?.priority || "",
        slideCreationTime: props.patient?.healthCareInfo?.[0]?.slideCreationTime || "",
        allergies: props.patient?.healthCareInfo?.[0]?.allergies || "",
        currentMedications: props.patient?.healthCareInfo?.[0]?.currentMedication || "",
        relevantMedicalHistory: props.patient?.healthCareInfo?.[0]?.realMedicalHistory || props.patient?.healthCareInfo?.[0]?.relMedicalHist || "",
        previousSurgeriesOrProcedures: props.patient?.healthCareInfo?.[0]?.prevSurgery || "",
      };

      return initialData
    }
  }

  let initialValues = getInitialValues()

  function convertTo12HourFormat(time) {
    const [hour, minute] = time?.split(':');
    const ampm = hour >= 12 ? 'PM' : 'AM';
    const adjustedHour = (hour % 12 || 12).toString().padStart(2, '0'); // Pad single-digit hour with '0'
    return `${adjustedHour}:${minute} ${ampm}`;
  }

  function convertTo24HourFormat(time) {
    const [timePart, modifier] = time?.split(' ');
    let [hour, minute] = timePart.split(':').map(Number);

    if (modifier === 'PM' && hour !== 12) {
      hour += 12;
    } else if (modifier === 'AM' && hour === 12) {
      hour = 0;
    }

    return `${hour?.toString().padStart(2, '0')}:${minute?.toString().padStart(2, '0')}:00`;
  }


  const handleSave = async (values: any) => {
    let payload;
    const finalSampleLocation = values?.sampleLocation === 'Other' ? values?.sampleLocationOther || '' : values?.sampleLocation;
    {
      (role === _roleType.technician || props.userRole === _roleType.technician) ? (
        payload = {
          "_id": props.patientDocID,
          "profileStep": props.PageNumber,
          "healthCareInfo": {
            "typeOfSample": values?.typeOfSample,
            "sampleLocation": finalSampleLocation,
            "sampleTime": convertTo12HourFormat(values?.sampleTime),
            "slideCreationTime": convertTo12HourFormat(values?.slideCreationTime),
            "priority": values?.priority,
          },
        }
      ) : (
        payload = {
          "_id": props.patientDocID,
          "profileStep": props.PageNumber,
          "healthCareInfo": [{
            "allergies": values.allergies,
            "currentMedication": values.currentMedications,
            "relMedicalHist": values.relevantMedicalHistory,
            "prevSurgery": values.previousSurgeriesOrProcedures
          }]
        }
      )
    }
    setLoad(true)
    const response = await apiRequest({ method: 'POST', endUrl: _patientUrls.add, headerType: 'json', body: payload })
    if (response.status) {
      setLoad(false)
      setIsSuccessModalOpen(true)
      setTimeout(() => {
        if (data.state.mode === 'edit') {
          navigate("/patientlist")
        }
        else {
          {
            (role === _roleType.technician || props.userRole === _roleType.technician) ? (
              navigate('/patientlist')
            ) : (
              navigate('/addappointment', { state: { userData: props?.patient, mode: "create", contactNumber: props?.contactNumber, patientName: props?.patientName, patientData: props?.patientData } })
            )
          }
        }
      }, 500);
    } else if (!response.status) {
      setLoad(false)
      uiNotificationService.show({
        title: "Error",
        type: "error",
        message: response.msg
        , position: "topRight"
      })
    }
  }

  return (
    <section className='form__section'>
      <Formik
        validationSchema={(role === _roleType.technician || props?.userRole === _roleType.technician) && sampleFormSchema}
        initialValues={initialValues}
        onSubmit={handleSave}
        enableReinitialize={true}
      >
        {({
          errors,
          values,
          handleChange,
          handleBlur,
          touched,
          setFieldValue,
          setFieldTouched,
        }) => (
          <Form >
            {(role === _roleType.technician || props.userRole === _roleType.technician) ? (
              <>
                <div className='formRow formRow__4'>
                  <div className='formCol'>
                    <div className="form__Field">
                      <label className="form__label" htmlFor='typeOfSample'>
                        Type of sample<span className="required-asterisk">*</span>
                      </label>
                      <select
                        className="form__select form__select--sm"
                        id="typeOfSample"
                        name="typeOfSample"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.typeOfSample}
                        autoComplete='off'
                        style={customStyle.select}
                      >
                        <option value="" disabled>Select</option>
                        <option value="Tissue">Tissue</option>
                        <option value="Liquid">Liquid</option>
                      </select>
                    </div>
                    <ErrorMessage name="typeOfSample" component="div" className="error text-error" />
                  </div>
                  <div className='formCol'>
                    <div className="form__Field">
                      <label className="form__label" htmlFor='sampleLocation' >
                        Sample Location<span className="required-asterisk">*</span>
                      </label>
                      <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
                        {values.typeOfSample === 'Tissue' ? (
                          <select
                            className="form__select form__select--sm"
                            id="sampleLocation"
                            name="sampleLocation"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.sampleLocation}
                            autoComplete='off'
                            style={{ ...customStyle.select, flex: 1 }}
                          >
                            <option value="" disabled>Select</option>
                            <option value="Breast">Breast</option>
                            <option value="Lung">Lung</option>
                            <option value="Colon">Colon</option>
                            <option value="Colorectal">Colorectal</option>
                            <option value="Prostate">Prostate</option>
                            <option value="Other">Other</option>
                          </select>
                        ) : (
                          <input
                            className="form__input form__input--sm"
                            type="text"
                            id="sampleLocation"
                            name="sampleLocation"
                            placeholder="Sample Location"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.sampleLocation}
                            autoComplete='off'
                            style={{ flex: 1 }}
                          />
                        )}

                        {values.typeOfSample === 'Tissue' && values.sampleLocation === 'Other' && (
                          <input
                            className="form__input form__input--sm"
                            type="text"
                            id="sampleLocationOther"
                            name="sampleLocationOther"
                            placeholder="Please specify"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.sampleLocationOther || ''}
                            autoComplete='off'
                            style={{ width: 220 }}
                          />
                        )}
                      </div>
                    </div>
                    <ErrorMessage name="sampleLocation" component="div" className="error text-error" />
                  </div>
                  <div className='formCol'>
                    <div className="form__Field">
                      <label className="form__label" htmlFor="sampleTime">
                        Sample Time<span className="required-asterisk">*</span>
                      </label>
                      <TimePicker
                        className='form__input form__input--sm'
                        use12Hours
                        format="hh:mm a"
                        value={
                          values.sampleTime
                            ? dayjs(values.sampleTime, "HH:mm:ss")
                            : null
                        }
                        onChange={(newValue) => {
                          if (newValue) {
                            const formattedTime = newValue?.format("HH:mm:ss");
                            setFieldValue("sampleTime", formattedTime)
                          }
                        }}
                      />
                    </div>
                    <ErrorMessage name="sampleTime" component="div" className="error text-error" />
                  </div>
                  <div className='formCol'>
                    <div className="form__Field">
                      <label className="form__label" htmlFor='slideCreationTime'>
                        Time of slide creation<span className="required-asterisk">*</span>
                      </label>
                      <TimePicker
                        className='form__input form__input--sm'
                        use12Hours
                        format="hh:mm a"
                        value={
                          values.slideCreationTime
                            ? dayjs(values.slideCreationTime, "HH:mm:ss")
                            : null
                        }
                        onChange={(newValue) => {
                          if (newValue) {
                            const formattedTime = newValue?.format("HH:mm:ss");
                            setFieldValue("slideCreationTime", formattedTime)
                          }
                        }}
                      />
                    </div>
                    <ErrorMessage name="slideCreationTime" component="div" className="error text-error" />
                  </div>
                  <div className='formCol'>
                    <div className="form__Field">
                      <label className="form__label" htmlFor='priority'>
                        Case Study :<span className="required-asterisk">*</span>
                      </label>
                      <select
                        className="form__select form__select--sm"
                        id="priority"
                        name="priority"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.priority}
                        autoComplete='off'
                        style={customStyle.select}
                      >
                        <option value="" disabled>Select</option>
                        <option value="Critical">Critical</option>
                        <option value="Priority">Priority</option>
                        <option value="Routine">Routine</option>
                      </select>
                    </div>
                    <ErrorMessage name="priority" component="div" className="error text-error" />
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className='flex justify-between mt-4 mx-8'>
                  <div className="form-container">
                    <div className="form-group mb-0">
                      <label className="form__label" htmlFor='allergies'>
                        Allergies
                      </label>
                      <textarea rows={1} cols={30}
                        id="allergies"
                        name="allergies"
                        placeholder="Allergies"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className='form__textarea form__textarea--sm'
                        value={values.allergies}
                      ></textarea>
                    </div>
                  </div>
                </div>
                <div className='flex justify-between mt-4 mx-8'>
                  <div className="form-container">
                    <div className="form-group mb-0">
                      <label className="form__label" >
                        Current Medications
                      </label>
                      <textarea rows={1} cols={30}
                        id="currentMedications"
                        name="currentMedications"
                        placeholder="Current Medications"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className='form__textarea form__textarea--sm'
                        value={values.currentMedications}
                      ></textarea>
                    </div>
                  </div>
                </div>
                <div className="flex justify-between mt-4 mx-8">
                  <div className="form-container">
                    <div className='form-group mb-0'>
                      <label className="form__label" htmlFor='relevantMedicalHistory'>
                        Relevant Medical History
                      </label>
                      <textarea rows={3} cols={30}
                        id="relevantMedicalHistory"
                        name="relevantMedicalHistory"
                        placeholder="Relevant Medical History"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.relevantMedicalHistory}
                        className='form__textarea form__textarea--sm'
                      >
                      </textarea>
                    </div>
                  </div>
                </div>
                <div className="flex justify-between mt-4 mx-8">
                  <div className="form-container">
                    <div className='form-group mb-0'>
                      <label className="form__label" htmlFor='previousSurgeriesOrProcedures'>
                        Previous Surgeries or Procedures
                      </label>
                      <textarea rows={3} cols={30}
                        id="previousSurgeriesOrProcedures"
                        name="previousSurgeriesOrProcedures"
                        placeholder="Previous Surgeries or Procedures"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.previousSurgeriesOrProcedures}
                        className='form__textarea form__textarea--sm'
                      >
                      </textarea>
                    </div>
                  </div>
                </div>
              </>
            )}
            <div className='btn__group mx-8'>
              <button
                className='btn btn__white'
                onClick={() => props.setPageNumber((prev) => prev - 1)}
              >
                Previous
              </button>
              <button
                className='btn btn__primary'
                type="submit"
              >
                {(role === _roleType.technician || role === _roleType.admin || props?.userRole === _roleType.technician) ? (
                  <>
                    {data.state.mode == 'create' ? 'Save' : 'Update'}
                  </>
                ) : (
                  <>
                    {data.state.mode == 'create' ? 'Save and Create Appointment' : 'Update'}
                  </>
                )}
              </button>
            </div>
          </ Form>
        )}
      </Formik>
      <Loader isLoaderOpen={load} />
      <SuccessModal
        isSuccessModalOpen={isSuccessModalOpen}
        title={`Patient ${data.state.mode == 'create' ? 'created' : 'updated'} successfully.`}
        handleCloseModal={() => setIsSuccessModalOpen(false)}
      />
    </section>
  )
}

export default AllregiesAndReasonForVisit
